/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=7abd6132"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__